export interface LoadingHandle {
  readonly element: HTMLElement;
  show(): void;
  hide(): void;
  update(opts: { message?: string; percent?: number }): void;
  isVisible(): boolean;
}

export interface LoadingOverlayProps {
  readonly message?: string;
  readonly percent?: number;
}

// 全画面グレーアウト + 中央スピナー(+任意メッセージ/残り%)。root は hidden トグル、
// 内側 centerer が flex 中央寄せ。絵文字なし(CSS スピナー)。
export function createLoadingOverlay(props: LoadingOverlayProps = {}): LoadingHandle {
  let visible = false;

  const root = document.createElement("div");
  root.className = "fixed inset-0 z-50 hidden bg-slate-900/40";
  root.setAttribute("role", "status");
  root.setAttribute("aria-live", "polite");
  root.setAttribute("aria-label", "読み込み中");

  const center = document.createElement("div");
  center.className = "flex min-h-full flex-col items-center justify-center";

  const spinner = document.createElement("div");
  spinner.className = "h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-shinonome-700";
  spinner.setAttribute("aria-hidden", "true");

  const message = document.createElement("p");
  message.className = "mt-4 text-sm text-white";
  message.dataset["testid"] = "loading-message";

  const percent = document.createElement("p");
  percent.className = "mt-1 text-xs text-slate-200";
  percent.dataset["testid"] = "loading-percent";

  center.append(spinner, message, percent);
  root.append(center);

  function render(opts: { message?: string; percent?: number }): void {
    if (opts.message !== undefined) message.textContent = opts.message;
    if (opts.percent !== undefined) {
      const p = Math.max(0, Math.min(100, Math.round(opts.percent)));
      percent.textContent = "残り " + p + "%";
      percent.classList.remove("hidden");
    }
  }

  if (props.message !== undefined) message.textContent = props.message;
  if (props.percent !== undefined) render({ percent: props.percent });
  else percent.classList.add("hidden");

  return {
    element: root,
    show() {
      visible = true;
      root.classList.remove("hidden");
    },
    hide() {
      visible = false;
      root.classList.add("hidden");
    },
    update(opts) {
      render(opts);
    },
    isVisible() {
      return visible;
    },
  };
}
